import { UsersService } from '../../service/users.service';
import { Component, OnInit } from '@angular/core';
import { environment } from './../../../environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CognitoUtil } from './../../service/cognito.service';
import * as moment from 'moment';
import {Moment} from 'moment';
import {SelectItemGroup} from 'primeng/components/common/api';
declare let $;
import * as _ from "lodash"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';
import {MessageService} from 'primeng/components/common/messageservice';
import { CitiesService } from './../../service/cities.service';
import {HomeService} from '../../service/home.service';
import { UserLoginService } from './../../service/user-login.service';
import {Sport} from '../../models/sport';
import {UserRegistrationService} from '../../service/user-registration.service';
import { ParksService } from '../../service/parks.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  somevalue: string = 'https://content.fieldsmanager.com/' + environment.logoStage + '/' + sessionStorage.getItem('cityId') + '.png';
  cityName: string;
  userName: string;
  user = 'false';
  reservation_history = false;
  userData: any;
  repInitials: any;
  repName: any;
  loadingBar: boolean = false;
  resHistory: any;
  upcomingTab: boolean = true;
  pastTab: boolean = false;
  active_view: any = 'large';
  tab_type:any = 'upcoming';
  selectedData:any = 'All';
  allResData:any;
  p: number = 1;
  groupedDates=[];
  selectedDate3:string;
  groupedCars: SelectItemGroup[];
  newgroupedData=[];
  newgroupedPastData=[];
  types=[];
  order:any;
  teamTab: boolean=false;
  teams = [];
  teamForm: FormGroup;
  inviteForm: FormGroup;
  formSubmitted: boolean = false;
  personaltab:boolean = true;
  profiletab:boolean=false;
  sessionstab:boolean=false;
  pre_tab_type:any = 'personal';
  phoneNumber: string;
  emailAddress:any;
  teamname:any;
  reservationtab:boolean=true;
  profileInfoForm: FormGroup;
  notifyInfoForm:FormGroup;
  secuirityInfoForm:FormGroup;
  residentInfoForm:FormGroup;
  addressInfoForm:FormGroup;
  servicesTab:boolean=false;
  refereeRequests=[];
  userAsReferee:boolean=false;
  refSportErr: boolean = false;
  servicesArr: any[] = [];
  refSport: any[] = [];
  userId: any;
  profileImage;
  editForm: FormGroup;
  deleteTeam:any;
  showTeam: any;
  refereetab:boolean=false;
  parkName:any;
  groundName:any;
  sportName:any;
  selectedDate;
  time1:any;
  time2:any;
  slotChangeForm: FormGroup;
  inviteFormSubmitted: boolean = false;
  futureSessionRes: any[] =[];
  pastSessionRes: any[]=[];
  sports: any[] = [];
  moment: any = moment;
  teamMembers: any[] = [];
  invite_option:boolean=false;
  removed_members:any=[];
  editedTmId: any;
  invitedTeam: any;
  inviteErrResMsg: any = '';
  inviteErrClass: string;
  inviteErrRes: boolean = false;
  invitation_id: string = null;
  team_id: string;
  public sportsList = [];
  referee_status:any;
  refereedSports:any=[];
  referee_id:any;
  rstatusSearch:string="Pending";
  cancelSlotId: any;
  cityId: any;
  reason: any;
  resv_id: any;
  feedback: boolean;
  sports_details: boolean;
  show_allSports: boolean;
  park_slotsDetails: boolean;
  reportIssue: boolean;
  support_requests: boolean;
  resStatus:boolean=false;
  meridian:any;
  inviteEmail:any;
  old_slot: any;
  firstname: string;
  lastname: string;
  checkValidation:boolean=false;
  checkValidation1:boolean=false;
  checkValidation2:boolean=false;
  userType: string;
  residentOf: string;
  sportpref:any[]=[];
  address:string;
  street:string;
  city:string;
  state:string;
  zipcode:string;
  current_sports_preferences:any;
  switchAdmin: string = "false";
  sessionHistory:any[]=[];
  activeStatus:any;
  passwordType: string = "password";
  newPassType: string = "password";
  cnfPassType: string = "password";

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public usersService: UsersService,
    private cognitoUtil: CognitoUtil,
    private formbuilder: FormBuilder,
    private messageService: MessageService,
    public citiesservice: CitiesService,
    public homeService: HomeService,
    private userService: UserLoginService,
    public userRegistration: UserRegistrationService,
    private parksservice: ParksService
    // private toastr: ToastrService
  ) {
   
    // this.userService.isAuthenticated(this);
    this.route.queryParams.subscribe(params => {
      this.invitation_id = params.invitation_id
        if (params.invitation_id && localStorage.getItem('id') === null) {
          localStorage.setItem('invitationId', params.invitation_id);
        }
        if (params.account) {
          this.myAccount();
        }
    });
    
    this.user = localStorage.getItem('user');
    if (this.user !== 'true') {
      this.router.navigate(['/home/signin',{param:'dashboard?invitation_id='+this.invitation_id}]);
    }

   }

  ngOnInit() {
    $('#from_date1').change((e)=> {
      this.selectedDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
    })

    $('.input-daterange').datepicker({})
    $('#from_date1').change((e)=> {
      $('.datepicker').hide();
    })

    this.cityId = sessionStorage.getItem('cityId');
    setTimeout(function(){
      this.profileImage="../../../assets/img/prf_icon.png";
      this.cityName = 'Marylebone';
      this.emailAddress = localStorage.getItem('email');
      this.street= localStorage.getItem('street');
      this.city=localStorage.getItem('city');
      this.state=localStorage.getItem('state');
      this.zipcode=localStorage.getItem('zipcode');
      this.current_sports_preferences=JSON.parse(localStorage.getItem('sportsPreferences'));
      this.phoneNumber = localStorage.getItem('phoneNumber');
      this.phoneNumber = this.phoneNumber.replace(/^\+[0-9]/, '');
      this.residentOf = localStorage.getItem('residentOf');
      this.user = localStorage.getItem('user');
      this.userName = localStorage.getItem('firstName');
      this.userId = localStorage.getItem('id');
      this.repInitials = localStorage.getItem('firstName').charAt(0) + localStorage.getItem('lastName').charAt(0);
      this.repName = localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName');
      this.firstname = localStorage.getItem('firstName');
      this.lastname = localStorage.getItem('lastName');
      this.userType = localStorage.getItem('userName');


      this.oldLname = localStorage.getItem('lastName');
      this.oldFname = localStorage.getItem('firstName');
      this.oldPhone = localStorage.getItem('phoneNumber')!==''?localStorage.getItem('phoneNumber').split('+1')[1]:'';
      this.oldResidentof = localStorage.getItem('residentOf');
      this.oldStreet= localStorage.getItem('street');
      this.oldCity=localStorage.getItem('city');
      this.oldState=localStorage.getItem('state');
      this.oldZipcode=localStorage.getItem('zipcode');

      //switch admin
      this.switchAdmin = localStorage.getItem('switchAdmin');


      if (this.userType.includes("Google") || this.userType.includes("Amazon") || this.userType.includes("Facebook")) {
        this.userType = 'social_login';
      } else {
        this.userType = 'custom_login';
      }
      this.userData = [{ 'value': '0', 'label': this.repName }, { 'value': '1', 'label': 'Logout' }]
      this.allResData=[{'label':'All','value':'1'}]
      console.log("userName::",this.userName)
      // get all teams
      this.getTeamsList(this.userId);
      if(this.invitation_id!=undefined){
        this.joinTeamCnfm(this.invitation_id, this.userId);
      }
      this.getRefereeStatus();
      this.getSessionHistory();
      this.getActivityStatus();
    }.bind(this), 100);
    
    this.teamForm = this.formbuilder.group({
      teamName: ['', Validators.required],
      sport: [null, Validators.required]
    });

    this.inviteForm = this.formbuilder.group({
      email: ['', Validators.required],
    })
    
    this.profileInfoForm = this.formbuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
    })

    this.notifyInfoForm=this.formbuilder.group({
      email: ['', Validators.required],
      phoneNumber: ['', Validators.required],
    })

    this.residentInfoForm=this.formbuilder.group({
      residentOf:['',Validators.required],
    })

    this.addressInfoForm=this.formbuilder.group({
      street:['',Validators.required],
      city:['',Validators.required],
      state:['',Validators.required],
      zipcode:['',Validators.required],
    })


    this.secuirityInfoForm=this.formbuilder.group({
      oldpassword: ['', Validators.required],
      newpassword: ['', Validators.required],
      confirmpassword: ['', Validators.required]
    })

    this.editForm=this.formbuilder.group({
      // tmPlayers: [''],
      name: ['', Validators.required],
      sport: [''],
      email:['']
    });

    this.slotChangeForm = this.formbuilder.group({
      park: ['', Validators.required],
      ground: ['', Validators.required],
      sport: [null, Validators.required],
      date: [this.selectedDate, Validators.required],
      startTime: ['startTime', Validators.required],
      endTime: ['endTime', Validators.required]
    });

    this.getServices();   
    // this.getRefereeDetails();

    this.citiesservice.currentMessage.subscribe(res => {
      if(res=='my reservations' || res=='default message'){
       this.tab_type='upcoming';
       this.getReservations('upcoming');
       this.pastTab=false;
      }
      else if(res=='past reservations'){
       this.tab_type= 'past';
       this.getReservations('past');
       this.upcomingTab=false;
      }
      else if(res=='referee'){
       this.tab_type='referee';
       this.getRefereeRequests('referee')
      }
    });

    this.getSports();
     
    setTimeout(function(){
      $(".selectpicker").selectpicker();
    }.bind(this), 1000);

  }

  showHidePass() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }

  showHideNewPass() {
    this.newPassType = this.newPassType === 'password' ? 'text' : 'password';
  }

  showHideCnfPass() {
    this.cnfPassType = this.cnfPassType === 'password' ? 'text' : 'password';
  }

  getSessionHistory(){
    this.userService.getsessionHistory(this.userId).subscribe(data => {
      if(data.history.length==0){
        this.sessionHistory=[];
      }
      else{
        this.sessionHistory=data.history;
      }
    },err => {
      console.log('this is the error', err);
      this.sessionHistory=[];
    })
  }

  getActivityStatus(){
    this.userService.getActivityStatus(this.userId).subscribe(data => {
      this.activeStatus=data;
    },err => {
      console.log('this is the error', err);
    })
  }

  onSwitchAdmin() {
    this.loadingBar = true;
    let params = sessionStorage.getItem('authorizationToken');
    
      this.userService.getAdminDetails(params).subscribe(data => {

        console.log('admin details', data);

        localStorage.setItem('cityAdmin', 'true');
        sessionStorage.setItem('cityId', data[0]['City_Id']);
        localStorage.setItem('cityId', data[0]['City_Id']);
        localStorage.setItem('repId', data[0]['Rep_Id']);
        localStorage.setItem('repName', data[0]['First_Name'] + ' ' + data[0]['Last_Name']);
        localStorage.setItem('repInitials', data[0]['First_Name'].charAt(0) + data[0]['Last_Name'].charAt(0));
        localStorage.setItem('paymentStatus',  data[0]['Payment_Status'])
        localStorage.setItem('planId',  data[0]['Plan_Id'])
        localStorage.setItem('planName',  data[0]['Plan_Name'])
        localStorage.setItem('subscriptionId',  data[0]['Subscription_Id'])
        localStorage.setItem('planPrice',  data[0]['Price'])
        localStorage.setItem('planUpdatedAt',  data[0]['Plan_Updated_At'])
        localStorage.setItem('sixMthPlan',  data[0]['active_six_months_subscription'])
        localStorage.setItem('User_Enabled',  data[0]['User_Enabled'])

        const params1 = {
          'cityId': sessionStorage.getItem('cityId'),
          'authorizationToken': sessionStorage.getItem('authorizationToken')
        };

        this.parksservice.getParks(params1).subscribe(response => {
        this.loadingBar = false;
        var noofParks;
        //for no parks admin
        if(localStorage.getItem('repName')=='madhu m'){
            noofParks=0;
        }
        else{
            noofParks=response.body.length;
        }
        //for no parks admin
        
        if (data[0]['Default_Park_Id'] === null || data[0]['Default_Park_Id'] === undefined) {
            this.router.navigate(['/parkDefaults']);
        }
        else if(noofParks==0){
            localStorage.setItem('defaultParkId', 'temp');
            this.router.navigate(['/admin/parks']);
        }
        else {
            localStorage.setItem('defaultParkId', data[0]['Default_Park_Id']);
            localStorage.setItem('defaultParkName', data[0]['Park_Name']);
            this.router.navigate(['/admin']);
        }
    })
    });
  }

  joinTeamCnfm(invitation_id, user_id) {
    if (this.invitation_id !== null) {
      this.homeService.joinTeamCnfm(invitation_id, user_id)
        .subscribe((res: any)=> {
        console.log('join team cnf', res);
        if (res) {
          this.getTeamsList(this.userId);
        }
      });
    }
  }

  confirmDeleteAccount(){
    $("#cmgSoonModal").modal('show');
  }

  deleteAccount(){
    this.loadingBar=true;
    this.userService.getUserSlotsCheck(this.userId).subscribe(res => {
     console.log("response::",res.body.Slots)
     this.loadingBar=false;
     if(res.body.Slots==0){
      this.messageService.add({
        severity: 'success',
        summary: 'Delete Account',
        detail: 'We miss you. Your account has been deleted successfully'
      });
      setTimeout(function(){
      this.router.navigate(['/home']);
      localStorage.clear();
      }.bind(this), 2000);
     }
     else{
      $("#futureSlotAvailModal").modal('show');
     }
    },err => {
      console.log('this is the error', err);
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Delete Account', 
        detail: 'please contact technical support at 214-206-8976' 
       });
    })
  }


  sportPreference(){
    this.loadingBar=true;
      let params = {
        'Sports_Preferences': this.sportpref,
        'userId': this.userId,
        'authorizationToken': sessionStorage.getItem('authorizationToken'),
        'AccessToken': sessionStorage.getItem('accessToken')
      };
      this.homeService.updateSportsPreferences(params)
      .subscribe((res: any) => {
        console.log('update res', res);
        localStorage.setItem('sportsPreferences',JSON.stringify(res.body.Sport_Names));
        this.current_sports_preferences=JSON.parse(localStorage.getItem('sportsPreferences'));
        this.loadingBar=false;
        this.checkValidation=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Update Preferences',
          detail: res.body.msg
        });
      });
  }

  onPickSlot(resv) {
    console.log('resv', resv);
    this.homeService.pickSlot(this.userId, resv.Reservation_Id, resv.Ref_Slot_Req_Id, this.referee_id,resv.City_Id)
      .subscribe((res: any)=> {
        console.log('pick slot res', res);
        this.messageService.add({ severity: 'success', summary: 'Referee', detail: res.body.msg });
        this.getRefereeDetails(this.userId, this.referee_id);
      });
  }

  gotoFeedback(resv) {
    this.resv_id = resv.Reservation_Id;
  this.router.navigate(['/home'],{queryParams:{'activeFeedback':true,'resv_id':this.resv_id}})
  }

  gotoReport(resv){
    this.resv_id = resv.Reservation_Id;
    this.router.navigate(['/home'],{queryParams:{'activeReport':true,'resv_id':this.resv_id}})
  }

  refereeRequest(slot){
    this.router.navigate(['/home/referee-bookings'], { queryParams: { sportId: slot.Sport_Id, resvId: slot.Reservation_Id }});
  }

  cancelSlot(resv) {
    this.cancelSlotId = resv.Slot_Id;
    $("#deleteSlotModal").modal('show');
  }

  cnfDelSlot(){
    let data = {
      slot_id: this.cancelSlotId,
      city_id: this.cityId,
      reason: this.reason,
      user_id:this.userId
    }
    $("#deleteSlotModal").modal('hide');
    this.homeService.cancelSlot(data)
      .subscribe((res: any)=> {
        console.log('cancel slot res', res);
        this.messageService.add({ severity: 'success', summary: 'Cancel Slot', detail: res.body.msg });
        this.futureReservations();
      });
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/signin']);
    }
  }


refereeUpdate(){
  this.resStatus = true;
  this.refSport.forEach(element => {
    this.refereedSports.push(parseInt(element));
  })
  this.homeService.refereeUpdate(this.userId,this.referee_id,this.refereedSports)
  .subscribe((res: any)=> {
    this.resStatus = false;
    console.log("referee update::",res);
    this.messageService.add({ severity: 'success', summary: 'Referee', detail: res.body.msg });
  }, (err: any)=> {
    console.log('err', err);
  })
}

  getTeamsList(user_id) {
    this.homeService.getTeamsList(user_id)
    .subscribe((res: any)=> {
      let teams_list = res;
      console.log('teams_list', teams_list);
      this.teams = teams_list;
    });
  }

  inviteMember(){
    this.invite_option=true;
  }

  getRefereeStatus(){
    this.refereedSports=[];
    this.homeService.getRefereeStatus(this.userId)
    .subscribe((res: any)=> {
      this.referee_status=res.ref_status;
       if(res.ref_status!==0){
          this.referee_id=res.data[0].Ref_Id
          // this.getRefereeRequests(this.userId,this.referee_id);
          this.getRefereeDetails(this.userId,this.referee_id)
          console.log('ref status::',res.ref_status);
          res.data.forEach(element => {
          this.refereedSports.push(element.Sport_Id)
          });
       }
    })
  }

  getSports() {
    this.homeService.getSports().subscribe((data) => {
      console.log('get sports data', data);
        this.sportsList = [];
        if (data.length === 0) {
        } else {
            data.forEach((o) => {
                const temp = {};
                temp['Sport_Id'] = o.Sport_Id;
                temp['Sport_Name'] = o.Sport_Name;
                temp['image'] = 'https://content.fieldsmanager.com/' + environment.logoStage + '/sports-images/' + o.Sport_Id + '.png';
                this.sportsList.push(temp);
            });
        }
    });
  }


  refereeSignup() {
    this.resStatus = true;
    if (this.refSport.length === 0) {
      this.refSportErr = true;
    } else {
      this.refSportErr = false;
      var data = { user_id: this.userId, sports: this.refSport }
      this.homeService.refereeSignup(data).subscribe((res: any)=> {
        console.log("referee res::",res);
        this.resStatus = false;
        this.messageService.add({ severity: 'success', summary: 'Referee', detail: 'referee request sent successfully' });
      }, (err: any)=> {
        this.resStatus = false;
        if (err.error && err.error.message === "Referee request already sent for this sports!") {
          this.messageService.add({ severity: 'error', summary: 'Referee', detail: 'Referee request already sent for this sports!' });
        }
      })
    }
  }
  

 
  toggleAccodion() {
    $(".selectpicker").selectpicker();
    $('.collapse').on('shown.bs.collapse', function(){
      $(this).parent().find(".fa-angle-down").removeClass("fa-angle-down").addClass("fa-angle-up");
      }).on('hidden.bs.collapse', function(){
      $(this).parent().find(".fa-angle-up").removeClass("fa-angle-up").addClass("fa-angle-down");
      });
  }

  getServices() {
    this.homeService.getServices()
      .subscribe((res: any)=> {
        console.log('services res', res);
        this.servicesArr = res;
    });
  }

  goHome(){
    this.router.navigate(['/home']);
  }

  myDashboard(){
    this.reservationtab=true;
    this.profiletab=false;
  }

  myAccount(){
    setTimeout(function(){
        var readURL = (input)=> {
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload =  (e:any)=> {
                    $('.profile-pic').attr('src', e.target.result);
                    this.profileImage=e.target.result;
                    console.log('upload Image::',this.profileImage);
                }
                reader.readAsDataURL(input.files[0]);
            }
        }
        $(".file-upload").on('change', function(){
            readURL(this);
        });
        $(".upload-button").on('click', function() {
           $(".file-upload").click();
        });
    }.bind(this), 100);
    
    this.profiletab=true;
    this.reservationtab=false;
    setTimeout(function () {
      $('.myTabs a:first').tab('show') 
      $('.selectpicker').selectpicker();
      }.bind(this),1000);
    setTimeout(function () {
      $("div#inlineEditWrapper a.c-inline-editor").addClass("fontset1");
    }.bind(this), 0);
  }

  onProfileEdit(){
    if(this.profileInfoForm.value.firstname!==undefined || this.profileInfoForm.value.lastname!==undefined){
    this.loadingBar = true;
    let params = {
      'first_name': this.profileInfoForm.value.firstname,
      'last_name': this.profileInfoForm.value.lastname,
      'user_id': localStorage.getItem('id')
    };
    this.userRegistration.updateDetails(params).subscribe((res:any) => {
      if (res.body.msg) {
        localStorage.setItem('firstName', res.body.first_name);
        localStorage.setItem('lastName', res.body.last_name);
        this.firstname = res.body.first_name;
        this.lastname = res.body.last_name;
        this.userName = localStorage.getItem('firstName');
        this.loadingBar=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Update user profile',
          detail: res.body.msg
        });
      }
    })
   }
  }

  onNotifyEdit(){
    if (this.phoneNumber !== "null" && this.phoneNumber !== "") {
      this.loadingBar=true;
      let params = {
        'phoneNumber': this.phoneNumber,
        'userId': this.userId,
        'authorizationToken': sessionStorage.getItem('authorizationToken'),
        'AccessToken': sessionStorage.getItem('accessToken')
      };
      this.homeService.updatePhone(params)
      .subscribe((res: any) => {
        console.log('update phone res', res);
        this.checkValidation=false;
        this.userService.updateCognitoAttributes('phone_number', "+1"+this.phoneNumber);
        localStorage.setItem('phoneNumber',this.phoneNumber);
        this.loadingBar=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Update phone number',
          detail: res.body.msg
        });
      });
    }
    else{
      this.checkValidation=true;
      this.loadingBar=false;
    }
  }

  onAddressEdit(){
    if ((this.street !== "null" && this.street !== "" && this.street !== undefined)&&(this.city !== "null" && this.city !== "" && this.city !== undefined)&&(this.state !== "null" && this.state !== "" && this.state !== undefined)&&(this.zipcode !== "null" && this.zipcode !== "" && this.zipcode !== undefined)){
    this.loadingBar=true;
      let params = {
        'street': this.street,
        'city': this.city,
        'state': this.state,
        'zipcode':this.zipcode,
        'userId': this.userId,
        'authorizationToken': sessionStorage.getItem('authorizationToken'),
        'AccessToken': sessionStorage.getItem('accessToken')
      };
      this.homeService.updateAddress(params)
      .subscribe((res: any) => {
        console.log('update res', res);
        this.loadingBar=false;
        this.checkValidation2=false;
        localStorage.setItem('street',this.street);
        localStorage.setItem('city', this.city);
        localStorage.setItem('state', this.state);
        localStorage.setItem('zipcode',this.zipcode);
      this.messageService.add({
          severity: 'success',
          summary: 'Update Address',
          detail: res.body.msg
        });
      });
    }
    else{
      this.checkValidation2=true;
      this.loadingBar=false;
    }
  }

  onResidentEdit(){
    this.loadingBar=true;
    if (this.residentOf !== "null" && this.residentOf !== "") {
      let params = {
        'residentOf': this.residentOf,
        'userId': this.userId,
        'authorizationToken': sessionStorage.getItem('authorizationToken'),
        'AccessToken': sessionStorage.getItem('accessToken')
      };
      this.homeService.updateResidentOf(params)
      .subscribe((res: any) => {
        console.log('update res', res);
        this.checkValidation1=false;
        localStorage.setItem('residentOf',this.residentOf);
        this.loadingBar=false;
        this.messageService.add({
          severity: 'success',
          summary: 'Update Resident',
          detail: res.body.msg
        });
      });
    }
    else{
      this.checkValidation1=true;
      this.loadingBar=false;
    }
  }

  
  onSecuirityEdit(){
    if(this.secuirityInfoForm.value.newpassword==this.secuirityInfoForm.value.confirmpassword){

      if(this.secuirityInfoForm.value.oldpassword!==undefined || this.secuirityInfoForm.value.newpassword!==undefined){
        // document.getElementById('confirm-submit').click();
        $('#deleteGroup').modal('show')
      }
      this.checkValidation=false;
    }
    else{
      this.checkValidation=true;
    }
  }

  confirmPasswordChange() {
    this.loadingBar=true;
    let params = {
        'PreviousPassword': this.secuirityInfoForm.value.oldpassword,
        'ProposedPassword': this.secuirityInfoForm.value.newpassword,
        'cityId': sessionStorage.getItem('cityId'),
        'authorizationToken': sessionStorage.getItem('authorizationToken'),
        'AccessToken': sessionStorage.getItem('accessToken')
    };

    this.userRegistration.changePassword(params).subscribe(response => {
        this.secuirityInfoForm.reset();
        this.loadingBar=false;
        if (response.body.name) {
          this.messageService.add({
            severity: 'error',
            summary: 'Password Update Failed!',
            detail: response.body.message
          });
        } else {
          this.messageService.add({
            severity: 'success',
            summary: 'Password successfully updated!',
            detail: response.body.message
          });

        }
        this.loadingBar = false;
    }, err => { this.errorHandle(err) });
}


  saveEditable(value,type){
    if(type=='repName'){
     this.repName=value;
    }
    else if(type=='cityName'){
     this.cityName=value;
    }
    else if(type == 'email'){
     this.emailAddress = value;
    }
    else if(type == 'phoneNumber'){
     this.phoneNumber = value;
    }
    else if(type == 'userName'){
     this.userName = value;
    }
 
    const obj=
    {
      'userId':localStorage.getItem('id'),
      'fullName':this.repName,
      'cityName':this.cityName,
      'email':this.emailAddress,
      'phoneNumber':this.phoneNumber,
      'userName':this.userName
    }
    console.log('obj Data::',obj)
   }

   getPersonalInfo(type){
    this.pre_tab_type = type;
   if(type === 'personal'){
    this.personaltab = true;
    this.servicesTab=false;
    this.sessionstab=false;
    setTimeout(function () {
      $('.myTabs a:first').tab('show') 
      $(".selectpicker").selectpicker();
      }.bind(this),0);
   }
   else if(type=='referee'){
     this.refereedSports.forEach(element => {
      setTimeout(function () {
        $("#fm"+element).prop("disabled", true);     
      }.bind(this),0);
     })

     this.servicesTab=true;
     this.personaltab = false;
     this.sessionstab=false;
    //  this.getRefereeDetails();
   }
   else if(type=='sessions'){
    this.servicesTab=false;
    this.personaltab = false;
    this.sessionstab=true;
  }
  }

  refereeStatus(e){
    console.log(e.target.checked);
    this.userAsReferee=e.target.checked
  }

  getRefereeDetails(userId,ref_id){
      this.homeService.getMyRefereereqs(userId,ref_id)
        .subscribe((res: any)=> {
          console.log('referee reqs res', res);
          if(res.msg==undefined){
            this.refereeRequests = res;
          }
        });
  }

  get teamName() {
    return this.teamForm.controls.teamName.valid;
  }
  get sport() {
    return this.teamForm.controls.sport.valid;
  }
  get users() {
    return this.teamForm.controls.users.valid;
  }
  get email() {
    return this.inviteForm.controls.email.valid;
  }

  inviteTeam(){
    this.formSubmitted = true;
    this.inviteErrRes = false;
    if(this.inviteForm.valid){
    console.log('invited team',this.invitedTeam);
    var obj = {
      team_id: this.invitedTeam.Team_Id,
      team_name: this.invitedTeam.Team_Name,
      user_id: this.userId,
      user_name: this.userName,
      email: this.inviteForm.controls.email.value
    }
    this.homeService.inviteTeam(obj)
      .subscribe((res: any)=> {
        this.formSubmitted = false;
        this.inviteErrRes = true;
        this.inviteForm.reset();
        this.inviteErrResMsg = res.body.msg;
        if (res.body.msg === "Email not found!") {
          this.inviteErrClass = 'text-danger';
        } else {
          this.inviteErrClass = 'text-success';
          setTimeout(() => {
            $("#inviteTeamModal").modal('hide');
          }, 2000);
        }
      });
    }
  }

  openInviteModal(team) {
    this.invitedTeam = team;
    this.formSubmitted = false;
    $("#inviteTeamModal").modal('show');
  }

  updateTeam(){
    console.log(this.editForm);
    this.formSubmitted = true;
    if((this.editForm.controls['name'].status !== 'INVALID' && this.editForm.controls['sport'].status !== 'INVALID' && !this.invite_option) || (this.invite_option && this.editForm.valid)){
      $("#editTeamModal").modal('hide');
      this.loadingBar = true;
      var obj = {
        team_id: this.editedTmId,
        team_name: this.editForm.controls.name.value, 
        members: this.removed_members,
        email:this.editForm.controls.email.value
      }
      this.homeService.updateTeam(obj)
      .subscribe((res: any)=> {
        this.loadingBar = false;
        this.formSubmitted =false;
        this.getTeamsList(this.userId);
        this.messageService.add({ severity: 'success', summary: 'Teams', detail: 'Team updated successfully' });
      });
      this.editForm.reset();
    }
  }

  onClickDeleteMember(member) {
    this.removed_members=[];
    this.teamMembers = this.teamMembers.filter(item => {
      if (item.TM_Id !== member.TM_Id) {
        return item;
        
      }
      else{
        this.removed_members.push(item.TM_Id)  
        console.log("removed Members::",this.removed_members);
      }
    });
  }

  OnClose(){
    this.inviteForm.reset();
    this.teamForm.reset();
    this.editForm.reset();
  }

  onCreateTeam() {
    this.formSubmitted = true;
    if(this.teamForm.valid){
      this.formSubmitted =false;
      $("#createTeamModal").modal('hide');
      this.loadingBar = true;
      var sport_details = this.sportsList.filter(res => res.Sport_Id == this.teamForm.controls.sport.value)[0];
      var sport_max_memebers = 0;
      if (sport_details.Sport_Name === "Cricket") {
        sport_max_memebers = 11;
      } else if (sport_details.Sport_Name === "Soccer") {
        sport_max_memebers = 15;
      } else if (sport_details.Sport_Name === "Baseball") {
        sport_max_memebers = 16;
      }

      var obj = {
        Team_Name: this.teamForm.controls.teamName.value, 
        Sport_Id: sport_details.Sport_Id, 
        Sport_Name: sport_details.Sport_Name, 
        Team_Max_Size: sport_max_memebers, 
        Team_Size: 1,
        Team_Created_By: this.userId 
      }

      this.homeService.createTeam(obj)
        .subscribe((res: any)=> {
          this.loadingBar = false;
          console.log('create team res', res);
          if (res.body.msg == "Team successfully added") {
            this.messageService.add({ severity: 'success', summary: 'Teams', detail: 'Team created successfully' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Teams', detail: "Team name already exists" });
          }
          this.getTeamsList(this.userId);
        });
      
      this.teamForm.reset();
    }
  }

  pageChanged(p){
  this.p=p;
  }

  onCurrentReservationsChange(param){
   if(param==1){
    this.futureReservations();
   }
  }

   onPastReservationsChange(param){
   if(param==1){
    this.pastReservations();
   }
  }

  toggleMenu() {
    console.log('top menu clicked');
  }
  updateUrl(event) {
    console.log('failed url:', this.somevalue);
    this.somevalue = 'https://content.fieldsmanager.com/System.png';
    console.log('new url:', this.somevalue);
  }

  logout() {
    this.user = 'false';
    if(localStorage.upgradeView==='true'){
      this.router.navigate(['/home']);
      localStorage.clear();
    }
    else{
      this.router.navigate(['/home']);
      localStorage.clear();
    }
  }

  gotoPage(params) {
    console.log('params', params)
    if (params === '1') {
      this.user = 'false';
      localStorage.clear();
      this.router.navigate(['/home/land']);
    }
  }

  getReservations(type) {
    this.tab_type = type;
    if (type === 'upcoming') {
      this.upcomingTab = true;
      this.pastTab = false;
        setTimeout(function () {
        var table = $('#resblk').dataTable({
          destroy: true,
          'bAutoWidth': false,
          'bPaginate': true,
          'sPaginationType': 'full_numbers',
          'iDisplayLength': 10,
          language: {
            'paginate': {
              'previous': "<i class='fa fa-backward'>",
              'next': "<i class='fa fa-forward'>",
              'first': "<i class='fa fa-step-backward'>",
              'last': "<i class='fa fa-step-forward'>"
            }
          }
        })
      }.bind(this), 0);
        this.futureReservations();
    } else if (type === 'past') {
     this.upcomingTab = false;
     this.pastTab = true;
     this.pastReservations();
    }
  }

  onActions(slot){

    this.old_slot = slot;
    this.parkName=slot.Park_Name,
    this.groundName=slot.Ground_Name,
    this.sportName=slot.Sport_Name,
    this.selectedDate=moment(new Date(slot.Reservation_Date)).format('YYYY-MM-DD');

    this.time1 = {
      hour: slot.Slot.split("-")[0].split(".")[0].split(":")[0], 
      minute: slot.Slot.split("-")[0].split(".")[0].split(":")[1].split(" ")[0], 
      second: 0
    };
    this.time2 = {
      hour: slot.Slot.split("-")[0].split(".")[0].split(":")[0], 
      minute: slot.Slot.split("-")[0].split(".")[0].split(":")[1].split(" ")[0], 
      second: 0
    };
    $("#actionEditModal").modal('show');
  }

  onInviteSlot() {
    console.log("Invite Slot::",this.inviteForm.value);
    this.inviteFormSubmitted = true;
    this.inviteForm.reset();
    $("#inviteSlotModal").modal('hide');
  }

  onUpdateSlot(){
    $("#actionEditModal").modal('hide');
    this.loadingBar = true;
    let new_slot = this.slotChangeForm.value;
    let slot = moment(this.time1['hour'] + ':' + this.time1['minute'], ['HH:mm']).format("hh:mm A") + ' - ' + moment(this.time2['hour'] + ':' + this.time2['minute'], ['HH:mm']).format("hh:mm A");
    
    let data = {
      reservation_id: this.old_slot.Reservation_Id, 
      user_id: this.userId,
      slot_id: this.old_slot.Slot_Id,
      city_id: this.old_slot.City_Id,
      req_date: new_slot.date,
      req_slot: slot
    }
    
    this.homeService.updateSlot(data)
    .subscribe((res: any) => {
      this.loadingBar = false;
      console.log('update slot res', res);
      this.messageService.add({ severity: 'success', summary: 'Edit Slot Request', detail: res.body.msg });
    });
    
  }

  
  futureReservations(){
    this.loadingBar = true;
    this.homeService.getFutureSessionRes(localStorage.getItem('id'),'future').subscribe((response:any) => {
      setTimeout(function(){
        if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
            var a=$('.ngx-pagination li:nth-last-child(2) span').text()
            this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
        }
        else{
          var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
        }
        }.bind(this), 0);
      this.futureSessionRes = response.reservations;
      this.loadingBar = false;
    })
  }

  pastReservations(){
    this.loadingBar = true;
    this.homeService.getpastReservations(localStorage.getItem('id'),'past').subscribe((response:any) => {
      setTimeout(function(){
        if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
            var a=$('.ngx-pagination li:nth-last-child(2) span').text()
            this.total_pages=a.slice(a.lastIndexOf(' ') + 1); 
        }
        else{
          var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
        }
        }.bind(this), 0);
      this.pastSessionRes = response.reservations;
      this.loadingBar = false;
    })
  }

  currentReservations() {
    console.log("=====Feature Reservations=======")
    if($("#Select1").val()==undefined)
    {
      setTimeout(function(){
      $("#Select1").prepend('<option value=All selected=selected style="font-weight:bold;">All</option>');
      }.bind(this), 0);
    }
    this.p=1;
    var year=$('#Select1 :selected').parent().attr('label');
    var mon =$('#Select1 :selected').text();
    if(year!=undefined){
      console.log("filterData::",year,moment().month(mon).format("MM"));
    }
    else{
     year='All',
     mon='All'
     console.log('AllData::',year,mon);
    }

    //let filter = {'month': '01', 'year': '2019'}
    let filter = {'month': moment().month(mon).format("MM"), 'year': year}

    this.reservation_history = false;
    this.resHistory = [];
    this.loadingBar = true;

    if(year!='All')
    {  
       //this.newgroupedData=[{label:'',value:'',items:[{label:'All',value:'All'}]}];
      //   this.usersService.getReservations(localStorage.getItem('id'), sessionStorage.getItem('cityId'), 'current', JSON.stringify(filter)).subscribe((response:any) => {
      // console.log('this is the filter data response', response.body.reservations);
      //this.resHistory = response.body.reservations;
      //this.resHistory = response.body.reservations;
       this.resHistory=[{"Reservation_Id":758,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+12222222222","Reservation_Date":"2019-05-25T00:00:00.000Z","Slot":"11:06 AM - 01:06 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Pending","Slot_Status":"Pending","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":764,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-04T00:00:00.000Z","Slot":"08:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":765,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-05T00:00:00.000Z","Slot":"03:45 PM - 05:45 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":766,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-06T00:00:00.000Z","Slot":"01:13 PM - 01:13 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":767,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-07T00:00:00.000Z","Slot":"04:50 PM - 06:50 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":768,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-03T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":769,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-03T00:00:00.000Z","Slot":"12:11 PM - 01:11 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":770,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":771,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"12:11 PM - 01:11 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":772,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-11T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Pending","Slot_Status":"Pending","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":773,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+12222222222","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"04:48 PM - 04:48 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":774,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-11T00:00:00.000Z","Slot":"04:48 PM - 04:48 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0}]


       setTimeout(function(){
       
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      
      console.log("=====Feature Reservations=======", this.total_pages)
      }.bind(this), 0);

      this.resHistory.sort((d1, d2) => new Date(d1.Reservation_Date).getTime() - new Date(d2.Reservation_Date).getTime());
      this.resHistory.reverse();
      this.loadingBar = false;
      if (this.resHistory.body.length === 0) {
        this.loadingBar = false;
        // this.noReservations = true;
      } else {
        // this.noReservations = false;

      //group dropdown
      this.groupedDates = _(this.resHistory)
      .groupBy(x => moment(x.Reservation_Date.split('T')[0]).format('YYYY'))
      .map((value, key) => ({label: key, value:key, items: (value.map((a) => moment(a.Reservation_Date.split('T')[0]).format('MMMM'))).filter((value, index, self) => self.indexOf(value) === index)}))
      .value();
      if(this.newgroupedData.length ==0)
      {
         this.groupedDates.map(item=>this.newgroupedData.push({label:item.label,value:item.label,items:item.items.map(x=> ({label:x,value:x}))}))
      }
      console.log("group dropdown data::",this.newgroupedData)
      //group dropdown
       
        this.resHistory.forEach((e, index, array) => {
          e.Reservation_Date = moment(e.Reservation_Date.split('T')[0]).format('MMM DD YYYY');
          if (e.Slot_Status === 'Cancelled') {
            e.Reservation_Status = 'Cancelled'
          }
        });

        this.loadingBar = false;
        setTimeout(function () {
          var table = $('#resblk').dataTable({
            // destroy: true,
            'bAutoWidth': false,
            'bPaginate': true,
            'sPaginationType': 'full_numbers',
            'iDisplayLength': 10,
            language: {
              'paginate': {
                'previous': "<i class='fa fa-backward'>",
                'next': "<i class='fa fa-forward'>",
                'first': "<i class='fa fa-step-backward'>",
                'last': "<i class='fa fa-step-forward'>"
              }
            }
          })
        }.bind(this), 0);
      }
  //   },err => {
  //     this.errorHandle(err)
  // });
    }
    else{
      // this.newgroupedData=[{label:'',value:'',items:[{label:'All',value:'All'}]}];
    //  this.usersService.getAllReservations(localStorage.getItem('id'), sessionStorage.getItem('cityId'), 'current').subscribe(response => {
    //   console.log('this is the all response', response.body.reservations);
      // this.resHistory = response.body.reservations;
       this.resHistory=[{"Reservation_Id":758,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+12222222222","Reservation_Date":"2019-05-25T00:00:00.000Z","Slot":"11:06 AM - 01:06 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Pending","Slot_Status":"Pending","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":764,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-04T00:00:00.000Z","Slot":"08:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":765,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-05T00:00:00.000Z","Slot":"03:45 PM - 05:45 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":766,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-06T00:00:00.000Z","Slot":"01:13 PM - 01:13 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":767,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-07T00:00:00.000Z","Slot":"04:50 PM - 06:50 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":768,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-03T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":769,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-03T00:00:00.000Z","Slot":"12:11 PM - 01:11 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":770,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 2},{"Reservation_Id":771,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"12:11 PM - 01:11 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":772,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-11T00:00:00.000Z","Slot":"07:59 PM - 08:59 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Pending","Slot_Status":"Pending","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 1},{"Reservation_Id":773,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+12222222222","Reservation_Date":"2019-06-10T00:00:00.000Z","Slot":"04:48 PM - 04:48 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0},{"Reservation_Id":774,"First_Name":"Veeru","Last_Name":"Koppisetti","Phone_Number":"+11111111111","Reservation_Date":"2019-06-11T00:00:00.000Z","Slot":"04:48 PM - 04:48 PM","Email":"kingveeru@yahoo.com","Reservation_Status":"Approved","Slot_Status":"Reserved","Address":"221b Baker St, Marylebone, London NW1 6XE, UK","Park_Name":"Marylebone Park","Sport_Name":"Soccer","Ground_Name":"Soccer Field", 'picked': 0}]


       setTimeout(function(){
       
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      
      console.log("=====Feature Reservations=======", this.total_pages)
      }.bind(this), 0);

      this.resHistory.sort((d1, d2) => new Date(d1.Reservation_Date).getTime() - new Date(d2.Reservation_Date).getTime());
      this.resHistory.reverse();
      this.loadingBar = false;
      if (this.resHistory.length === 0) {
        this.loadingBar = false;
        // this.noReservations = true;
      } else {
        // this.noReservations = false;

      //group dropdown
      this.groupedDates = _(this.resHistory)
      .groupBy(x => moment(x.Reservation_Date.split('T')[0]).format('YYYY'))
      .map((value, key) => ({label: key, value:key, items: (value.map((a) => moment(a.Reservation_Date.split('T')[0]).format('MMMM'))).filter((value, index, self) => self.indexOf(value) === index)}))
      .value();
      if(this.newgroupedData.length ==0)
      {
      this.groupedDates.map(item=>this.newgroupedData.push({label:item.label,value:item.label,items:item.items.map(x=> ({label:x,value:x}))}))
      }
      console.log("group dropdown data::",this.newgroupedData)
      //group dropdown
       
        this.resHistory.forEach((e, index, array) => {
          e.Reservation_Date = moment(e.Reservation_Date.split('T')[0]).format('MMM DD YYYY');
          if (e.Slot_Status === 'Cancelled') {
            e.Reservation_Status = 'Cancelled'
          }
        });

        this.loadingBar = false;
        setTimeout(function () {
          var table = $('#resblk').dataTable({
            // destroy: true,
            'bAutoWidth': false,
            'bPaginate': true,
            'sPaginationType': 'full_numbers',
            'iDisplayLength': 10,
            language: {
              'paginate': {
                'previous': "<i class='fa fa-backward'>",
                'next': "<i class='fa fa-forward'>",
                'first': "<i class='fa fa-step-backward'>",
                'last': "<i class='fa fa-step-forward'>"
              }
            }
          })
        }.bind(this), 0);
      }
  //   },err => {
  //     this.errorHandle(err)
  // });
    }
  
  }

  reservationHistory() {
    console.log("=====Past Reservations=======")
    if($("#Select2").val()==undefined)
    {
      setTimeout(function(){
      $("#Select2").prepend('<option value=All selected=selected style="font-weight:bold;">All</option>');
      }.bind(this), 0);
    }
    this.p=1;
    var year=$('#Select2 :selected').parent().attr('label');
    var mon =$('#Select2 :selected').text();
    if(year!=undefined){
      console.log("filterData::",year,moment().month(mon).format("MM"));
    }
    else{
     year='All',
     mon='All'
     console.log('AllData::',year,mon);
    }
    
    let filter = {'month': moment().month(mon).format("MM"), 'year': year}
    //let filter = {'month': '01', 'year': '2019'}
    this.resHistory = [];
    this.reservation_history = true;
    this.loadingBar = true;

     if(year!='All')
    {  
       //this.newgroupedData=[{label:'',value:'',items:[{label:'All',value:'All'}]}];
    this.usersService.getReservations(localStorage.getItem('id'), sessionStorage.getItem('cityId'), 'history', JSON.stringify(filter)).subscribe(response => {
      console.log('this is the filter response', response.body.reservations);
      this.resHistory = response.body.reservations;
      
       setTimeout(function(){
       
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1); 
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      
      console.log("=====Past Reservations=======", this.total_pages)
      }.bind(this), 0);

      this.resHistory.sort((d1, d2) => new Date(d1.Reservation_Date).getTime() - new Date(d2.Reservation_Date).getTime());
      this.resHistory.reverse();
      this.loadingBar = false;

      if (response.body.length === 0) {
        this.loadingBar = false;
        // this.noReservations = true;
      } else {
        // this.noReservations = false;
        
        //group dropdown
        this.groupedDates = _(this.resHistory)
        .groupBy(x => moment(x.Reservation_Date.split('T')[0]).format('YYYY'))
        .map((value, key) => ({label: key, value:key, items: (value.map((a) => moment(a.Reservation_Date.split('T')[0]).format('MMMM'))).filter((value, index, self) => self.indexOf(value) === index)}))
        .value();
        if(this.newgroupedPastData.length ==0)
      {  
        
        this.groupedDates.map(item=>this.newgroupedPastData.push({label:item.label,value:item.label,items:item.items.map(x=> ({label:x,value:x}))}))
       }
        console.log("group dropdown data::",this.newgroupedPastData)
        //group dropdown

        this.resHistory.forEach((e, index, array) => {
          e.Reservation_Date = moment(e.Reservation_Date.split('T')[0]).format('MMM DD YYYY');
          if (e.Slot_Status === 'Cancelled') {
            e.Reservation_Status = 'Cancelled'
          }
        });
        this.loadingBar = false;
        setTimeout(function () {
          var table = $('#resblk').dataTable({
            // destroy: true,
            'bAutoWidth': false,
            'bPaginate': true,
            'sPaginationType': 'full_numbers',
            'iDisplayLength': 10,
            language: {
              'paginate': {
                'previous': "<i class='fa fa-backward'>",
                'next': "<i class='fa fa-forward'>",
                'first': "<i class='fa fa-step-backward'>",
                'last': "<i class='fa fa-step-forward'>"
              }
            }
          })
        }.bind(this), 0);
      }


    },
      err => {
        this.errorHandle(err);
      });
   }
   else{
     //this.newgroupedData=[{label:'',value:'',items:[{label:'All',value:'All'}]}];
    this.usersService.getAllReservations(localStorage.getItem('id'), sessionStorage.getItem('cityId'), 'history').subscribe(response => {
      console.log('this is the all response', response.body.reservations);
      this.resHistory = response.body.reservations;
      
       setTimeout(function(){
       
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1); 
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      
      console.log("=====Past Reservations=======", this.total_pages)
      }.bind(this), 0);

      this.resHistory.sort((d1, d2) => new Date(d1.Reservation_Date).getTime() - new Date(d2.Reservation_Date).getTime());
      this.resHistory.reverse();
      this.loadingBar = false;

      if (response.body.length === 0) {
        this.loadingBar = false;
        // this.noReservations = true;
      } else {
        // this.noReservations = false;
        
        //group dropdown
        this.groupedDates = _(this.resHistory)
        .groupBy(x => moment(x.Reservation_Date.split('T')[0]).format('YYYY'))
        .map((value, key) => ({label: key, value:key, items: (value.map((a) => moment(a.Reservation_Date.split('T')[0]).format('MMMM'))).filter((value, index, self) => self.indexOf(value) === index)}))
        .value();
        if(this.newgroupedPastData.length ==0)
      {  

        this.groupedDates.map(item=>this.newgroupedPastData.push({label:item.label,value:item.label,items:item.items.map(x=> ({label:x,value:x}))}))
      }
        console.log("group dropdown data::",this.newgroupedPastData)
        //group dropdown

        this.resHistory.forEach((e, index, array) => {
          e.Reservation_Date = moment(e.Reservation_Date.split('T')[0]).format('MMM DD YYYY');
          if (e.Slot_Status === 'Cancelled') {
            e.Reservation_Status = 'Cancelled'
          }
        });
        this.loadingBar = false;
        setTimeout(function () {
          var table = $('#resblk').dataTable({
            // destroy: true,
            'bAutoWidth': false,
            'bPaginate': true,
            'sPaginationType': 'full_numbers',
            'iDisplayLength': 10,
            language: {
              'paginate': {
                'previous': "<i class='fa fa-backward'>",
                'next': "<i class='fa fa-forward'>",
                'first': "<i class='fa fa-step-backward'>",
                'last': "<i class='fa fa-step-forward'>"
              }
            }
          })
        }.bind(this), 0);
      }


    },
      err => {
        this.errorHandle(err);
      });
   }

  }

  activeView(param){
    this.p=1;
    if(param === 'large'){
      this.active_view='large';
       setTimeout(function(){
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1); 
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }      
      }.bind(this), 0);
    }
    else{
       setTimeout(function(){
      if($('.ngx-pagination li:nth-last-child(1) a span').val()==undefined){
          var a=$('.ngx-pagination li:nth-last-child(2) span').text()
          this.total_pages=a.slice(a.lastIndexOf(' ') + 1); 
      }
      else{
        var a=$('.ngx-pagination li:nth-last-child(2) a span').text()
        this.total_pages=a.slice(a.lastIndexOf(' ') + 1);
      }
      }.bind(this), 0);
      this.active_view='short';
    }
  }

  errorHandle(err) {
    if (err.status === 401) {
      this.loadingBar = false;
    } else if (err.status === 400 || err.status === 404 || err.status === 500) {
      this.loadingBar = false;
    }
  }

  getTeams(type){
    this.teamTab=true;
    this.upcomingTab = false;
    this.pastTab = false;
    this.tab_type=type;
    this.refereetab=false;
  }

  getRefereeRequests(type){
    this.teamTab=false;
    this.upcomingTab = false;
    this.pastTab = false;
    this.refereetab=true;
    this.tab_type=type;
  }

  editTeam(team) {
    this.invite_option=false;
    this.loadingBar = true;
    this.removed_members=[];
    this.editedTmId = team.Team_Id;
    console.log(team)
    this.editForm.setValue({
      name: team.Team_Name,
      sport: team.Sport_Name,
      email: ''
    })
    this.homeService.getTeamMembers(team.Team_Id)
      .subscribe((res: any)=> {
        console.log('team members res', res);
        this.loadingBar = false;
        let team_members = res;
        if (team_members.length > 0) {
          this.teamMembers = team_members;
          $('#editTeamModal').modal('show');
        }
      });
  }
  selectDltTeam(team){
    console.log("deleted team", team)
    this.deleteTeam = team;
  }
  cnfrmDeltTeam(team){
    console.log("confrm deleted team ",team)
    this.homeService.deleteTeam(team.Team_Id)
      .subscribe((res: any)=> {
        if (res) {
          this.getTeamsList(this.userId);
          this.messageService.add({ severity: 'success', summary: 'Teams', detail: 'Team deleted successfully' });
        }
      });
  }
  viewTeam(team){
    this.showTeam = team;
    this.loadingBar = true;
    this.homeService.getTeamMembers(team.Team_Id)
    .subscribe((res: any)=> {
      console.log('team members res', res);
      this.loadingBar = false;
      let team_members = res;
      if (team_members.length > 0) {
        this.teamMembers = team_members;
        $('#viewTeamModal').modal('show');
      }
    });
  }

}
